"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronConfig = void 0;
var react_1 = __importDefault(require("react"));
var server_1 = __importDefault(require("react-dom/server"));
var Chevron_1 = __importDefault(require("@CommonFrontend/Public/Widgets/Chevron"));
var chevronStyles = __importStar(require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Chevron/ChevronWidget.css"));
var Types_1 = require("@CommonFrontendBackend/Account/Types");
exports.ChevronConfig = {
    type: "chevron",
    tokenType: {},
    publicRender: function (_a) {
        var _b;
        var attributes = _a.attributes, style = _a.style, token = _a.token;
        return server_1.default.renderToString(react_1.default.createElement(Chevron_1.default, {
            attributes: attributes,
            clickToScroll: (_b = token.clickToScroll) !== null && _b !== void 0 ? _b : true,
            style: style,
        }));
    },
    traits: {
        styleable: {
            styleKey: "chevron",
            properties: [
                {
                    defaultValue: { value: "#FFFFFF", themeIndex: 0 },
                    label: "Background color",
                    path: "backgroundColor",
                    type: "color",
                    variable: chevronStyles.backgroundColor,
                    groupKey: "Tab 1",
                },
                {
                    defaultValue: "S",
                    label: "Size",
                    path: "size",
                    options: [
                        {
                            applies: [
                                { variable: chevronStyles.padding, value: "16px" },
                                { variable: chevronStyles.fontSize, value: "24px" },
                            ],
                            label: "S",
                            value: "S"
                        },
                        {
                            applies: [
                                { variable: chevronStyles.padding, value: "12px" },
                                { variable: chevronStyles.fontSize, value: "48px" },
                            ],
                            label: "M",
                            value: "M"
                        },
                        {
                            applies: [
                                { variable: chevronStyles.padding, value: "8px" },
                                { variable: chevronStyles.fontSize, value: "64px" },
                            ],
                            label: "L",
                            value: "L",
                        }
                    ],
                    type: "enumerable",
                    groupKey: "Tab 2",
                },
                {
                    if: function (elementStyle) { return elementStyle["size"] === "L"; },
                    defaultValue: 0,
                    label: "Border Radius",
                    max: 50,
                    min: 0,
                    path: "borderRadius",
                    suffix: "px",
                    type: "numerical",
                    variable: chevronStyles.borderRadius,
                    withSlider: true,
                    groupKey: "Tab 2",
                },
            ],
            styleAccessKey: Types_1.StyleAccessType.ToolbarTable
        },
    },
};
